import { ValidatorFn, FormGroup, ValidationErrors } from '@angular/forms';

export const hasNoEmptySpacesValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const valid = control.value.trim();
  return (valid ? null : {'noEmptySpaces': true});
};
